import {
    GET_PRODUCT_LISTING,
    GET_PRODUCT_LISTING_SUCCESS,
    GET_PRODUCT_LISTING_FAIL,
    BULK_ATTACH_PDF,
    BULK_ATTACH_PDF_SUCCESS,
    BULK_ATTACH_PDF_FAIL,
    GET_PRODUCT_LISTING_FOR_GIFT,
    GET_PRODUCT_LISTING_FOR_GIFT_SUCCESS,
    GET_PRODUCT_LISTING_FOR_GIFT_FAIL,
    GET_PRODUCT_LISTING_FOR_ACCESORIES,
    GET_PRODUCT_LISTING_FOR_ACCESORIES_SUCCESS,
    GET_PRODUCT_LISTING_FOR_ACCESORIES_FAIL,
    GET_PRODUCT_DETAILS,
    GET_PRODUCT_DETAILS_SUCCESS,
    GET_PRODUCT_DETAILS_FAIL,
    ADD_PRODUCT,
    ADD_PRODUCT_SUCCESS,
    ADD_PRODUCT_FAIL,
    APPROVE_REJECT_PRODUCT,
    APPROVE_REJECT_PRODUCT_SUCCESS,
    APPROVE_REJECT_PRODUCT_FAIL,
    UPDATE_PRODUCT,
    UPDATE_PRODUCT_SUCCESS,
    UPDATE_PRODUCT_FAIL,
    DELETE_PRODUCT,
    DELETE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_FAIL,
    DELETE_BULK_PRODUCT,
    DELETE_BULK_PRODUCT_SUCCESS,
    DELETE_BULK_PRODUCT_FAIL,
    EXPORT_PRODUCT,
    EXPORT_PRODUCT_SUCCESS,
    EXPORT_PRODUCT_FAIL,
    IMPORT_PRODUCT_IMAGE,
    IMPORT_PRODUCT_IMAGE_SUCCESS,
    IMPORT_PRODUCT_IMAGE_FAIL,
    IMPORT_PRODUCT,
    IMPORT_PRODUCT_SUCCESS,
    IMPORT_PRODUCT_FAIL,
    RESET_PRODUCT_STATE,
    RESET_IMPORT_STATE,
    PRE_ADD_DATA,
    PRE_ADD_DATA_SUCCESS,
    PRE_ADD_DATA_FAIL,
} from "./actionTypes";


export const preAddData = (product) => ({
    type: PRE_ADD_DATA,
    payload: product,
});

export const preAddDataSuccess = (product) => ({
    type: PRE_ADD_DATA_SUCCESS,
    payload: product,
});


export const preAddDataFail = (product) => ({
    type: PRE_ADD_DATA_FAIL,
    payload: product,
});


export const getProductListing = (product) => ({
    type: GET_PRODUCT_LISTING,
    payload: product,
});

export const getProductListingSuccess = product => ({
    type: GET_PRODUCT_LISTING_SUCCESS,
    payload: product,
});

export const getProductListingFail = error => ({
    type: GET_PRODUCT_LISTING_FAIL,
    payload: error,
});

export const getProductListingForGift = (product) => ({
    type: GET_PRODUCT_LISTING_FOR_GIFT,
    payload: product,
});

export const getProductListingForGiftSuccess = product => ({
    type: GET_PRODUCT_LISTING_FOR_GIFT_SUCCESS,
    payload: product,
});

export const getProductListingForGiftFail = error => ({
    type: GET_PRODUCT_LISTING_FOR_GIFT_FAIL,
    payload: error,
});

export const getProductListingForAccessories = (product) => ({
    type: GET_PRODUCT_LISTING_FOR_ACCESORIES,
    payload: product,
});

export const getProductListingForAccessoriesSuccess = product => ({
    type: GET_PRODUCT_LISTING_FOR_ACCESORIES_SUCCESS,
    payload: product,
});

export const getProductListingForAccessoriesFail = error => ({
    type: GET_PRODUCT_LISTING_FOR_ACCESORIES_FAIL,
    payload: error,
});

export const getProductDetails = productId => ({
    type: GET_PRODUCT_DETAILS,
    payload: productId,
});

export const getProductDetailsSuccess = product => ({
    type: GET_PRODUCT_DETAILS_SUCCESS,
    payload: product,
});

export const getProductDetailsFail = error => ({
    type: GET_PRODUCT_DETAILS_FAIL,
    payload: error,
});

export const createProduct = product => ({
    type: ADD_PRODUCT,
    payload: product,
});

export const createProductSuccess = product => ({
    type: ADD_PRODUCT_SUCCESS,
    payload: product,
});

export const createProductFail = error => ({
    type: ADD_PRODUCT_FAIL,
    payload: error,
});

export const approveRejectProduct = product => ({
    type: APPROVE_REJECT_PRODUCT,
    payload: product,
});

export const approveRejectProductSuccess = product => ({
    type: APPROVE_REJECT_PRODUCT_SUCCESS,
    payload: product,
});

export const approveRejectProductFail = error => ({
    type: APPROVE_REJECT_PRODUCT_FAIL,
    payload: error,
});

export const updateProduct = product => ({
    type: UPDATE_PRODUCT,
    payload: product,
});

export const updateProductSuccess = product => ({
    type: UPDATE_PRODUCT_SUCCESS,
    payload: product,
});

export const updateProductFail = error => ({
    type: UPDATE_PRODUCT_FAIL,
    payload: error,
});

export const deleteProduct = productId => ({
    type: DELETE_PRODUCT,
    payload: productId,
});

export const deleteProductSuccess = productId => ({
    type: DELETE_BULK_PRODUCT_SUCCESS,
    payload: productId,
});

export const deleteProductFail = error => ({
    type: DELETE_PRODUCT_FAIL,
    payload: error,
});

export const deleteBulkProduct = productId => ({
    type: DELETE_BULK_PRODUCT,
    payload: productId,
});

export const deleteBulkProductSuccess = productId => ({
    type: DELETE_PRODUCT_SUCCESS,
    payload: productId,
});

export const deleteBulkProductFail = error => ({
    type: DELETE_BULK_PRODUCT_FAIL,
    payload: error,
});

export const exportProduct = data => ({
    type: EXPORT_PRODUCT,
    payload: data,
});

export const exportProductSuccess = data => ({
    type: EXPORT_PRODUCT_SUCCESS,
    payload: data,
});

export const exportProductFail = error => ({
    type: EXPORT_PRODUCT_FAIL,
    payload: error,
});

export const importProduct = (data) => ({
    type: IMPORT_PRODUCT,
    payload: data,
});


export const importProductSuccess = data => ({
    type: IMPORT_PRODUCT_SUCCESS,
    payload: data,
});

export const importProductFail = error => ({
    type: IMPORT_PRODUCT_FAIL,
    payload: error,
});
//import product image
export const importProductImage = (data) => ({
    type: IMPORT_PRODUCT_IMAGE,
    payload: data,
});


export const importProductImageSuccess = data => ({
    type: IMPORT_PRODUCT_IMAGE_SUCCESS,
    payload: data,
});

export const importProductImageFail = error => ({
    type: IMPORT_PRODUCT_IMAGE_FAIL,
    payload: error,
});

export const bulkAttachPdf = data => ({
    type: BULK_ATTACH_PDF,
    payload: data,
});

export const bulkAttachPdfSuccess = data => ({
    type: BULK_ATTACH_PDF_SUCCESS,
    payload: data,
});

export const bulkAttachPdfFail = error => ({
    type: BULK_ATTACH_PDF_FAIL,
    payload: error,
});

//reset
export const resetProductState = () => {
    return {
        type: RESET_PRODUCT_STATE,
    }
}

//reset
export const resetImportState = () => {
    return {
        type: RESET_IMPORT_STATE,
    }
}

